import { Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Row = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.disabled};
  padding: ${spacing('lg')} 0;
`;
